// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header___Qles","container":"styles_container__D4Avc","title":"styles_title__zn0Er","wrapper":"styles_wrapper__kRuW1","answer":"styles_answer__3fpnA"};